/* eslint-disable */
import React, { FC, ReactNode, useEffect, useState } from 'react';
import styles from '../../styles/components/controlVariations/ConfirmDownloadModal.module.css';
import PopupMobileModal from '../common/PopupMobileModal';

const ELEVATED_Z_INDEX = 1000000;

interface Props {
	open: boolean;
	onClose: () => void;
	children: ReactNode;
	elevated?: boolean;
}

const ResponsiveModal: FC<Props> = ({ open, onClose, children, elevated = false }) => {
	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		const check = () => setIsMobile(window.innerWidth <= 768);
		check();
		window.addEventListener('resize', check);
		return () => window.removeEventListener('resize', check);
	}, []);

	if (!open) return null;

	const elevatedStyle = elevated ? { zIndex: ELEVATED_Z_INDEX } : undefined;

	if (isMobile) {
		return (
			<PopupMobileModal open={open} onClose={onClose} style={elevatedStyle}>
				{children}
			</PopupMobileModal>
		);
	}

	return (
		<div className={styles.overlay} style={elevatedStyle}>
			{children}
		</div>
	);
};

export default ResponsiveModal;
